import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useMobile } from 'src/hooks/useMobile';
import { useTheme } from '@mui/material/styles';
import { SocialIcons, SocialIconsProps } from '../socials/SocialIcons';
import { DistributeButtonsProps } from '../DistributeButtons';

type GameInteractionsProps = Pick<SocialIconsProps, 'linkedSocials'> & {
  playGameFn?: () => void;
  mintNowFn?: () => void;
  isGamePlaying?: boolean;
  distributeButtonsProps?: DistributeButtonsProps;
  gameUrl?: string;
  gameEmbedded: boolean;
};

export const GAME_EMBEDDED_TITLES = [
  'Fantom Survivor',
  'ev.io',
  'Mighty Action Heroes',
  'Blockchain Brawlers',
  'Mecha World',
];

export function GameInteractions({
  playGameFn,
  mintNowFn,
  distributeButtonsProps,
  linkedSocials,
  isGamePlaying,
  gameUrl,
  gameEmbedded = false,
}: GameInteractionsProps) {
  const theme = useTheme();
  const isMobile = useMobile();

  if (!playGameFn && !mintNowFn && !distributeButtonsProps) {
    return null;
  }

  return (
    <Box display={'flex'} flexDirection={isMobile ? 'column' : 'row'}>
      {(!!playGameFn || !!mintNowFn) && (
        <Box
          flexGrow={1}
          display={'flex'}
          flexDirection={'row'}
          alignItems="center"
        >
          {!!playGameFn && (
            <Button
              onClick={playGameFn}
              href={gameEmbedded ? undefined : gameUrl}
              variant="contained"
              size="large"
              sx={{
                flexGrow: 1,
                mr: !!playGameFn && !!mintNowFn ? 1 : 0,
              }}
            >
              {isGamePlaying ? 'Stop Playing' : 'Play Game'}
            </Button>
          )}
          {!!mintNowFn && (
            <Button
              onClick={mintNowFn}
              variant="contained"
              size="large"
              sx={{
                flexGrow: 1,
                maxWidth: 400,
                ml: !!playGameFn && !!mintNowFn ? 1 : 0,
                background: `${theme.palette.secondary.vertical}`,
                boxShadow: '0.5px 2px 0px #0D4E6A',
              }}
            >
              Mint Now
            </Button>
          )}
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          mt: isMobile ? 4 : 0,
          ml: isMobile ? 0 : 4,
          gap: 2,
          justifyContent: 'space-between',
        }}
      >
        <SocialIcons typographyVariant="h4" linkedSocials={linkedSocials} />
        {/* TODO: reintroduce share/notifications buttons
         <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          {!!distributeButtonsProps && (
            <DistributeButtons {...distributeButtonsProps} />
          )}
        </Box> */}
      </Box>
    </Box>
  );
}
